<template>
  <div class=" justify-end right-0">
    <div aria-hidden="true" class="absolute right-0 sm:right-0 z-50 justify-end items-start flex ">
      <div
          class=" flex flex-col w-fit bg-white border-t text-lg font-medium rounded-lg border-gray-200 shadow p-4 mt-2 ">
        <div class="flex justify-between">
          <p>{{ $t('header.datePicker.title') }}</p>
          <svg @click="closeDateRangePicker" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
               stroke-width="1.5" stroke="currentColor" class="w-6 h-6 cursor-pointer">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </div>
        <select @change="changePresetDate($event)" v-model="selectedDate" name="dateSelection"
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-200 focus:outline-none sm:text-sm rounded-md">
          <option value="range">{{ $t('header.datePicker.options.range') }}</option>
          <option value="today">{{ $t('header.datePicker.options.today') }}</option>
          <option value="yesterday">{{ $t('header.datePicker.options.yesterday') }}</option>
          <option value="last7Days">{{ $t('header.datePicker.options.last7Days') }}</option>
          <option value="thisWeek">{{ $t('header.datePicker.options.thisWeek') }}</option>
          <option value="last30Days">{{ $t('header.datePicker.options.last30Days') }}</option>
          <option value="thisMonth">{{ $t('header.datePicker.options.thisMonth') }}</option>
          <option value="lastYear">{{ $t('header.datePicker.options.lastYear') }}</option>
          <option value="thisYear">{{ $t('header.datePicker.options.thisYear') }}</option>
        </select>
        <div class="h-64 my-2  flex flex-col" ref="dateRangePickerPlace" @click="showDateRange">
          <input ref="dateRangePicker" type="text" class="text-center mb-2">
          <!-- date range picker-->
        </div>
        <p class="mt-28">{{ $t('header.datePicker.compareTo.title') }}</p>
        <select v-if="compareTo === 'PREVIOUS_PERIOD' " ref="compareSelect" name="dateSelection"
                class=" block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-200 focus:outline-none sm:text-sm rounded-md">
          <option selected value="PREVIOUS_PERIOD">{{ $t('header.datePicker.compareTo.previousPeriod') }}</option>
          <option value="PREVIOUS_YEAR">{{ $t('header.datePicker.compareTo.previousYear') }}</option>
        </select>
        <select v-if="compareTo !== 'PREVIOUS_PERIOD' " ref="compareSelect" name="dateSelection"
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-2 border-gray-200 focus:outline-none sm:text-sm rounded-md">
          <option value="PREVIOUS_PERIOD">{{ $t('header.datePicker.compareTo.previousPeriod') }}</option>
          <option selected value="PREVIOUS_YEAR">{{ $t('header.datePicker.compareTo.previousYear') }}</option>
        </select>
        <div class="flex flex-row justify-between mt-4">
          <button @click="closeDateRangePicker" type="button"
                  class=" inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2  font-medium importantText shadow-sm hover:bg-gray-50  sm:mt-0  w-auto text-sm">
            {{ $t('header.datePicker.cancel') }}
          </button>
          <button @click="applyDateRangePicker" type="button"
                  class=" inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2  font-medium importantText shadow-sm hover:bg-gray-50  sm:mt-0  w-auto text-white text-sm headerButtons">
            {{ $t('header.datePicker.apply') }}
          </button>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="absolute right-4 sm:right-0  z-49 justify-end items-start flex w-fit -my-14 ">
      <div class="flex w-fit flex-col items-center space-y-4 ">
        <transition enter-active-class="transform ease-out duration-300 transition"
                    enter-from-class="translate-y-8 opacity-0" enter-to-class="translate-y-0 opacity-100 "
                    leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                    leave-to-class="opacity-0">
          <div v-if="wrongInputDate"
               class="pointer-events-auto w-full overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div class="p-4 w-full">
              <div class="flex w-full items-center">
                <div class="flex w-full flex-1 justify-between">
                  <p class="w-full text-sm flex text-gray-900">
                    {{ $t('header.datePicker.wrongStartDate', {date: minStartDate}) }} </p>
                </div>
                <div class="ml-4 flex flex-shrink-0">

                  <button type="button" @click="wrongInputDate = false"
                          class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2">
                    <span class="">X</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import Litepicker from 'litepicker';
import 'litepicker/dist/plugins/mobilefriendly';
import {ref, defineEmits, defineProps, onMounted} from "vue";
import ApiService from "@/services/ApiService";
import moment from 'moment';

let picker = ref(null);
import {useApiStore} from "@/stores/ApiStore";

const apiDataStore = useApiStore();
const props = defineProps({
  showDatePicker: Boolean,
  startDate: String,
  endDate: String,
  compareTo: String
})
const minStartDate = ref("2023-01-01");
// let maxSelectedDate = ref(new Date().toISOString().split('T')[0])
let emit = defineEmits(["closeDateRangePicker", "applyDateRangePicker", "initDateRangePicker"]);

let compareSelect = ref(null);
let dateRangePicker = ref(null);
let wrongInputDate = ref(false);
let apiService = new ApiService()
let selectedDate = ref("last7Days");

function changePresetDate(e) {
  let minDate = moment(Date.parse(minStartDate.value)).subtract(1, 'd');
  let startDate = new Date();
  let endDate = new Date();
  switch (e.target.value) {
    case "range":
    case "today":
      picker.value.setDateRange(startDate, endDate);
      break;
    case "yesterday":
      startDate.setDate(startDate.getDate() - 1);
      endDate.setDate(endDate.getDate() - 1)
      picker.value.setDateRange(startDate, endDate);
      break;
    case "last7Days":
      startDate.setDate(startDate.getDate() - 6);
      picker.value.setDateRange(startDate, endDate);
      break;
    case "thisWeek":
      startDate = new Date(new Date().setDate((new Date().getDate() - new Date().getDay() + 1)));
      endDate = new Date(new Date().setDate((new Date().getDate() - new Date().getDay() + 1) + 6));
      picker.value.setDateRange(startDate, endDate);
      break;
    case "last30Days":
      startDate.setDate(startDate.getDate() - 30);
      picker.value.setDateRange(startDate, endDate);
      break;
    case "thisMonth":
      startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
      endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      picker.value.setDateRange(startDate, endDate);
      break;
    case "lastYear":
      startDate = new Date(startDate.setFullYear(new Date().getFullYear() - 1))
      if (startDate<=minDate){
        startDate = new Date(new Date().getFullYear(), 0, 1);
      }
      picker.value.setDateRange(startDate, endDate);
      break;
    case "thisYear":
      startDate = new Date(startDate.getFullYear(), 0, 1);
      endDate = new Date(getLastDayOfYear(endDate.getFullYear()))
      picker.value.setDateRange(startDate, endDate);
      break;
  }
}

function closeDateRangePicker() {
  emit("closeDateRangePicker");
}


async function applyDateRangePicker() {
  let string = dateRangePicker.value.value;
  // 2023-02-01 - 2023-02-15
  let startString = string.toString().substring(0, 10)
  let endString = string.toString().substring(13, 23)
  let startDate = moment(startString, getDateFormat(apiDataStore.getLang))
  let endDate = moment(endString, getDateFormat(apiDataStore.getLang))
  let minDate = moment(Date.parse(minStartDate.value)).subtract(1, 'd')

  // Check if startDate is before minStartDate
  if (startDate.isBefore(minDate)) {
    if (!wrongInputDate.value) {
      wrongInputDate.value = true
      const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(5000)
      wrongInputDate.value = false
    }
  } else {
    let compare = compareSelect.value.value;
    getInformation(startDate.toDate(), endDate.toDate(), compare);
    emit("closeDateRangePicker");
    emit("applyDateRangePicker", [startDate.toDate(), endDate.toDate(), compare]);
    wrongInputDate.value = false
  }
}

function showDateRange() {
  selectedDate.value = "range";
}

function getLastDayOfYear(year) {
  return new Date(year, 11, 31);
}

function getInformation(startDate, endDate, compare) {
  setDateRangePicker(startDate, endDate)
  apiService.updateDateRange(startDate, endDate, compare);
}

onMounted(() => {
  {
    let startDate = moment(props.startDate, "YYYY-MM-DD").toDate();
    let endDate = moment(props.endDate, "YYYY-MM-DD").toDate();
    let compare = compareSelect.value.value;
    getInformation(startDate, endDate, compare);
  }
})

function setDateRangePicker(startDate, endDate) {
  if (picker.value != null) {
    picker.value.destroy()
  }
  picker.value = new Litepicker({
    element: dateRangePicker.value,
    plugins: ['mobilefriendly'],
    autoRefresh: true,
    singleMode: false,
    inlineMode: true,
    startDate: startDate,
    endDate: endDate,
    numberOfColumns: 2,
    numberOfMonths: 2,
    lang: apiDataStore.getLang,
    tooltipText: {
      "one": getDay(apiDataStore.getLang),
      "other": getDays(apiDataStore.getLang)
    },
    format: getDateFormat(apiDataStore.getLang),
    lockDays: [['0000-01-01', "2022-12-31"]]
  });
  picker.value.setDateRange(startDate, endDate);
  let compare = compareSelect.value.value;
  emit("initDateRangePicker", [props.startDate.substring(0, 10), props.endDate.substring(0, 10), compare]);
}

function getDay(lang) {
  switch (lang) {
    case 'nl':
      return 'dag';
    case 'de':
      return 'tag';
    case 'en':
      return 'day';
    case 'fr':
      return 'jour';
    default:
      return ' ';
  }
}

function getDays(lang) {
  switch (lang) {
    case 'nl':
      return 'dagen';
    case 'de':
      return 'Tage';
    case 'en':
      return 'days';
    case 'fr':
      return 'jours';
    default:
      return 'Invalid language code';
  }
}

function getDateFormat(lang) {
  switch (lang) {
    case 'nl':
      return 'DD/MM/YYYY';
    case 'de':
      return 'DD.MM.YYYY';
    case 'en':
      return 'MM/DD/YYYY';
    case 'fr':
      return 'DD/MM/YYYY';
    default:
      return 'Invalid language code';
  }
}

</script>


